import React, { useState, useEffect } from "react";
import { Grid, message, notification, Button } from "antd";
import Helper from "./../lib/helper";
import Server from "./../lib/getAPI";
import dayjs from "dayjs";
import Images from "./../asset/exportImages";
const { useBreakpoint } = Grid;
export const GlobalState = React.createContext();

export default function AuthProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [listOfInsuredPeople, setListOfInsuredPeople] = useState([]);
  const [buyerInfo, setBuyerInfo] = useState({});
  const [dataOrder, setDataOrder] = useState({typeVAT: 'PERSONAL'});
  const [dataFees, setDataFees] = useState({
    totalInsured: 0, // số tiền bảo hiểm
    subsidyAmount: 0, // số tiền trợ giá
    redeemCode: '',  // mã code giảm giá
    discountAmount: 0, // số tiền giảm giá tùu mã ưu đãi
    commision: 0, // hoa hồng của sản phẩm
    reward: 0, // tiền thưởng trên gsale
    subsidies: 0 // số tiền trợ giá tối đa
  });
  const [step, setStep] = useState(1);
  const [configs, setConfigs] = useState([]);
  const [packages, setPackages] = useState([]);
  const isMobile = useBreakpoint().xs;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      localStorage.setItem("listInsuredTNGD", JSON.stringify(listOfInsuredPeople));
      localStorage.setItem("buyerInfoTNGD", JSON.stringify(buyerInfo));
      localStorage.setItem("dataOrderTNGD", JSON.stringify(dataOrder));
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [buyerInfo, dataOrder, listOfInsuredPeople]);

  useEffect(() => {
    getPackeds();
    let dataOrderTNGD = JSON.parse(localStorage.getItem('dataOrderTNGD'));
    let listInsuredTNGD = JSON.parse(localStorage.getItem('listInsuredTNGD'));
    let buyerInfoTNGD = JSON.parse(localStorage.getItem('buyerInfoTNGD'));
    // Nếu qua ngày thì không lưu các dữ liệu trường ngày tháng
    let resetLocalStorage = dataOrderTNGD?.dateSaveData === dayjs().format('DD/MM/YYYY');
    if (resetLocalStorage === false) {
      buyerInfoTNGD = {
        ...buyerInfoTNGD,
        buyerDob: undefined,
        beginDate: undefined,
        endDate: undefined
      }
    }
    if (dataOrderTNGD) {
      setDataOrder({
        ...dataOrderTNGD,
        typeVAT: dataOrderTNGD?.typeVAT || 'PERSONAL'
      });
    }
    if (buyerInfoTNGD) {
      setBuyerInfo(buyerInfoTNGD);
    }
    if (listInsuredTNGD) {
      setListOfInsuredPeople(listInsuredTNGD);
    }
  }, []);

  // Lấy danh sách gói bảo hiểm
  const getPackeds = () => {
    setLoading(true);
    Server.apicall(
      "GET",
      `/api/v1/product/family-accident/packages`
    )
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setPackages(res?.data?.data);
        }
      })
      .catch((err) => {
        // setLoading(false);
        if (err.response) {
          messageErr(err.response.data.statusCode, err.response.data.message);
        }
      });
  };

  // Thêm xoá sửa danh sách người bao hiểm
  const ActionList = (action, index, value) => {
    let listIsured = listOfInsuredPeople;
    switch (action) {
      case "unshift":
        listIsured.unshift({ ...value });
        setListOfInsuredPeople([...listIsured]);
        // message.success("Thêm người được bảo hiểm thành công");
        break;
      case "delete":
        listIsured.splice(index, 1);
        setListOfInsuredPeople([...listIsured]);
        break;
      case "add":
        listIsured.push({ ...value });
        setListOfInsuredPeople([...listIsured]);
        message.success("Thêm người được bảo hiểm thành công");
        break;
      case "edit":
        listIsured[index] = { ...value };
        setListOfInsuredPeople([...listIsured]);
        if (listIsured[index].self) return;
        message.success("Cập nhật thành công");
        break;
    }
  };

  const OpenLink = (link) => {
    if(!link){
      message.warning('Đang cập nhật!');
      return
    }
    if (Helper.getParamUrlByKey('platform') === 'app') {
      window.ReactNativeWebView.postMessage(`/gotoBrownser?link=${link}`);
      return;
    }
    window.open(link, "_blank");
  };

  const messageErr = (code, data) => {
    switch (code) {
      default:
        message.error(code + ' | Có lỗi xảy ra. Vui lòng kiểm tra lại!');
        break;
    }
  }

  const scrollIntoViewID = (id) => {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 100; // trừ 100px
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 200);
  }

  const validatePeople = (cccd, currentIndex) => {
    const existingIds = new Set(
      listOfInsuredPeople
        .filter((_, index) => index !== currentIndex) // bỏ người đang edit
        .map(p => p.insuredPrivateId)
    );

    if (existingIds.has(cccd)) {
      message.error(
        <span>
          CCCD/Số định danh đã có trong danh sách người được bảo hiểm
        </span>
      );
      return true; // báo trùng
    }

    return false; // không trùng
  };


  //Them notification
  const [api, contextHolder] = notification.useNotification({
  });

  const openNotification = (message_, code) => {
    api.open({
      message: (
        <div style={{ display: "flex" }}>
          <div>
            <img
              src={Images.ICErr}
              width={24}
              height={24}
              style={{ marginRight: "6px" }}
            />
          </div>{" "}
          <div>Thông báo</div>
        </div>
      ),
      description: (
        <div>
          <div>{message_}</div>
          <div
            style={{
              height: 0.5,
              width: "100%",
              background: "#D2D2D2",
              margin: "10px 0px",
            }}
          ></div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              margin: "auto",
            }}
          >
            <div style={{ color: "red", fontWeight: "500", textAlign: "center" }}>{`${code}`}</div>
            <Button
              style={{ margin: "10px auto", width: "120px" }}
              onClick={() => {
                navigator.clipboard
                  .writeText(code)
                  .then(() => message.success("Đã sao chép lỗi."))
                  .catch((err) => message.error("Copy lỗi:", err));
              }}
            >
              Sao Chép ID Lỗi
            </Button>
          </div>
        </div>
      ),
      duration: 9,
    });
  };

  return (
    <GlobalState.Provider
      value={{
        step, setStep, isMobile, ActionList, listOfInsuredPeople, Helper, loading, setLoading, OpenLink, setConfigs,
        buyerInfo, setBuyerInfo, configs, packages, setPackages, dataOrder, setDataOrder, dataFees, setDataFees,
        messageErr, scrollIntoViewID, validatePeople, setListOfInsuredPeople, openNotification
      }}
    >
      {contextHolder}
      {children}
    </GlobalState.Provider>
  );
}